module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAZlBMVEUAAAD/qkb/qkb/qkb/qkb/qkb/qkb/qkb/qkb/qkb/qkb/qkb/qkb/qkb/qkb/qkb/qkb/qkb/qkb/qkb/qkb/qkb/qkb/qkb/qkb/qkb/qkb/qkb/qkb/qkb/qkb/qkb/////69RDiKVzAAAAH3RSTlMA+tEG2MCOgT4yJBEL9e3p38fDurinn5h2Y1pJLBYBWN/WRAAAAHNJREFUGNOVzUcOhDAUBNFvmwyTcyy4/yUBAzLGG6jlU0st2yu1rgJ8QLK0DFC5byYC0MbDFNtzboWCpoFd4ewfA3UNXB2+mJD3ZL+9w0M54g2H3Af7ANgjW9ZbdcQrMh0m+EtSkVwtUX3lRFAs5xAvsroWOtwVQqS8YpcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/paySystem/icon_prompt.png
// module id = S7hs
// module chunks = 2